import styles from "../../pages/my-account/my-account.module.scss";
import Address from "./address";
import {format} from "date-fns";
import Price from "../price/price";
import Link from "next/link";
import React, {useState} from "react";
import {OrderDTO} from "../../interfaces/customer-interface";
import {useTranslation} from "next-i18next";

export const MyAccountOrder = (props: {
    order: OrderDTO
}) => {

    const {t} = useTranslation('common');
    const [orderOpen, setOrderOpen] = useState<boolean>(false);

    return (
        <div key={props.order.id} className={styles["order-line"]}>
            <div
                className={styles["order-resume"]}
                onClick={() => setOrderOpen(bool => !bool)}
            >
                <div className={styles["order-resume-infos"]}>
                    <p>{t("MY_ACCOUNT_ORDER_NUM")}{props.order.orderId}</p>
                    <p>{format(props.order.orderDate, 'dd/MM/yyyy H:mm')}</p>
                </div>

                <div className={styles["order-resume-actions"]}>
                    <div className={styles["order-price"]}>
                        <Price
                            price={props.order.cart.totals.totalWithTax}
                            page={'my-account-h'}
                            customCurrency={props.order.cart.currency}
                        />
                    </div>

                    {props.order.deliveryNotePath &&
                        <a href={props.order.deliveryNotePath}
                           target={"_blank"} className={styles["tooltip"]}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="48.5" height="50"
                                 viewBox="0 0 48.5 50">
                                <defs>
                                    <style>{'.ic-account-delivery-a{fill:#2a2a2a;}'}</style>
                                </defs>
                                <g transform="translate(-1002 -907)">
                                    <g transform="translate(892 907)">
                                        <path className={styles["ic-account-delivery-a"]}
                                              d="M19,2A17,17,0,0,0,2,19V31A17,17,0,0,0,19,48H29.5a17,17,0,0,0,17-17V19a17,17,0,0,0-17-17H19m0-2H29.5a19,19,0,0,1,19,19V31a19,19,0,0,1-19,19H19A19,19,0,0,1,0,31V19A19,19,0,0,1,19,0Z"
                                              transform="translate(110)"/>
                                    </g>
                                    <g transform="translate(1014.25 919.92)">
                                        <path className={styles["ic-account-delivery-a"]}
                                              d="M9,6.19a1,1,0,0,1-.5-.134L-.5.866A1,1,0,0,1-.866-.5,1,1,0,0,1,.5-.866l9,5.19A1,1,0,0,1,9,6.19Z"
                                              transform="translate(7.5 4.21)"/>
                                        <path className={styles["ic-account-delivery-a"]}
                                              d="M12,23a3,3,0,0,1-1.5-.4l-7-4A3.011,3.011,0,0,1,2,16V8A3.009,3.009,0,0,1,3.5,5.4l7-4a3,3,0,0,1,3,0l7,4A3.011,3.011,0,0,1,22,8v8a3.009,3.009,0,0,1-1.5,2.6l-7,4A3,3,0,0,1,12,23ZM12,3a1,1,0,0,0-.5.134l-7,4A1,1,0,0,0,4,8v8a1,1,0,0,0,.5.864l7,4a1,1,0,0,0,1,0l7-4A1,1,0,0,0,20,16V8a1,1,0,0,0-.5-.864l-7-4A1.006,1.006,0,0,0,12,3Z"/>
                                        <path className={styles["ic-account-delivery-a"]}
                                              d="M12,13.01a1,1,0,0,1-.5-.134l-8.73-5.05a1,1,0,0,1,1-1.731L12,10.855l8.229-4.76a1,1,0,0,1,1,1.731l-8.73,5.05A1,1,0,0,1,12,13.01Z"/>
                                        <path className={styles["ic-account-delivery-a"]}
                                              d="M0,11.08a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1,1,1,0,0,1,1,0V10.08A1,1,0,0,1,0,11.08Z"
                                              transform="translate(12 12)"/>
                                    </g>
                                </g>
                            </svg>
                            <span className={styles["tooltiptext"]}>{t("MY_ACCOUNT_ORDER_SEE_DELIVERY_NOTE")}</span>
                        </a>}

                    {props.order.billPath &&
                        <a href={props.order.billPath}
                           target={"_blank"} className={styles["tooltip"]}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="48.5" height="50"
                                 viewBox="0 0 48.5 50">
                                <defs>
                                    <style>{'.ic-account-invoice-a{fill:#2a2a2a;}'}</style>
                                </defs>
                                <g transform="translate(-1057 -1307)">
                                    <g transform="translate(947 1307)">
                                        <path className={styles["ic-account-invoice-a"]}
                                              d="M19,2A17,17,0,0,0,2,19V31A17,17,0,0,0,19,48H29.5a17,17,0,0,0,17-17V19a17,17,0,0,0-17-17H19m0-2H29.5a19,19,0,0,1,19,19V31a19,19,0,0,1-19,19H19A19,19,0,0,1,0,31V19A19,19,0,0,1,19,0Z"
                                              transform="translate(110)"/>
                                    </g>
                                    <g transform="translate(1069 1320)">
                                        <path className={styles["ic-account-invoice-a"]}
                                              d="M6,1h8a1,1,0,0,1,.707.293l6,6A1,1,0,0,1,21,8V20a3,3,0,0,1-3,3H6a3,3,0,0,1-3-3V4A3,3,0,0,1,6,1Zm7.586,2H6A1,1,0,0,0,5,4V20a1,1,0,0,0,1,1H18a1,1,0,0,0,1-1V8.414Z"/>
                                        <path className={styles["ic-account-invoice-a"]}
                                              d="M20,9H14a1,1,0,0,1-1-1V2a1,1,0,0,1,2,0V7h5a1,1,0,0,1,0,2Z"/>
                                        <path className={styles["ic-account-invoice-a"]}
                                              d="M8,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H8A1,1,0,0,1,9,0,1,1,0,0,1,8,1Z"
                                              transform="translate(8 13)"/>
                                        <path className={styles["ic-account-invoice-a"]}
                                              d="M8,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H8A1,1,0,0,1,9,0,1,1,0,0,1,8,1Z"
                                              transform="translate(8 17)"/>
                                        <path className={styles["ic-account-invoice-a"]}
                                              d="M10,10H8A1,1,0,0,1,8,8h2a1,1,0,0,1,0,2Z"/>
                                    </g>
                                </g>
                            </svg>
                            <span className={styles["tooltiptext"]}>{t("MY_ACCOUNT_ORDER_SEE_BILL")}</span>
                        </a>}
                    {props.order.creditPath &&
                        <a href={props.order.creditPath}
                           target={"_blank"} className={styles["tooltip"]}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="48.5" height="50"
                                 viewBox="0 0 48.5 50">
                                <defs>
                                    <style>{'.ic-account-invoice-a{fill:#2a2a2a;}'}</style>
                                </defs>
                                <g transform="translate(-1057 -1307)">
                                    <g transform="translate(947 1307)">
                                        <path className={styles["ic-account-invoice-a"]}
                                              d="M19,2A17,17,0,0,0,2,19V31A17,17,0,0,0,19,48H29.5a17,17,0,0,0,17-17V19a17,17,0,0,0-17-17H19m0-2H29.5a19,19,0,0,1,19,19V31a19,19,0,0,1-19,19H19A19,19,0,0,1,0,31V19A19,19,0,0,1,19,0Z"
                                              transform="translate(110)"/>
                                    </g>
                                    <g transform="translate(1069 1320)">
                                        <path className={styles["ic-account-invoice-a"]}
                                              d="M6,1h8a1,1,0,0,1,.707.293l6,6A1,1,0,0,1,21,8V20a3,3,0,0,1-3,3H6a3,3,0,0,1-3-3V4A3,3,0,0,1,6,1Zm7.586,2H6A1,1,0,0,0,5,4V20a1,1,0,0,0,1,1H18a1,1,0,0,0,1-1V8.414Z"/>
                                        <path className={styles["ic-account-invoice-a"]}
                                              d="M20,9H14a1,1,0,0,1-1-1V2a1,1,0,0,1,2,0V7h5a1,1,0,0,1,0,2Z"/>
                                        <path className={styles["ic-account-invoice-a"]}
                                              d="M8,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H8A1,1,0,0,1,9,0,1,1,0,0,1,8,1Z"
                                              transform="translate(8 13)"/>
                                        <path className={styles["ic-account-invoice-a"]}
                                              d="M8,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H8A1,1,0,0,1,9,0,1,1,0,0,1,8,1Z"
                                              transform="translate(8 17)"/>
                                        <path className={styles["ic-account-invoice-a"]}
                                              d="M10,10H8A1,1,0,0,1,8,8h2a1,1,0,0,1,0,2Z"/>
                                    </g>
                                </g>
                            </svg>
                            <span className={styles["tooltiptext"]}>{t("MY_ACCOUNT_ORDER_SEE_CREDIT")}</span>
                        </a>}
                    <div className={styles["order-status-" + props.order.status]}>
                        {t("MY_ACCOUNT_ORDER_STATUS_" + props.order.status)}
                    </div>
                </div>
            </div>

            <div className={orderOpen ? styles["order-details"] : styles["order-details-close"]}>

                <div className={styles["order-items-list"]}>
                    {
                        props.order.cart.products.map(product => (
                            <Link key={product.productId + "" + props.order.orderId}
                                  href={`/product/${product.productSlug}`}>
                                <div className={styles["item"]}>
                                    <img className={styles["item-image"]} src={product.image} alt={product.name}/>
                                    <p className={styles["item-title"]}>{product.name}</p>
                                    <p className={styles["item-quantity-price"]}>
                                        {t("MY_ACCOUNT_ORDER_QUANTITY")}
                                        {product.quantity} {" / "}
                                        {t("MY_ACCOUNT_ORDER_UNIT_PRICE")}

                                        {
                                            product.price.originalAmountWithTax && <Price
                                                price={product.price.originalAmountWithTax}
                                                page={'my-account'}
                                                strike={true}
                                                customCurrency={props.order.cart.currency}
                                            />
                                        }{" "}
                                        <Price
                                            price={product.price.amountWithTax}
                                            page={'my-account'}
                                            customCurrency={props.order.cart.currency}
                                        />
                                    </p>
                                </div>
                            </Link>

                        ))
                    }

                </div>


                <div className={styles["order-delivery-row"]}>

                    <div>
                        <p className={styles["subtitle"]}>{t("MY_ACCOUNT_DELIVERY")}</p>
                        {
                            props.order.delivery &&
                            <>
                                <p>{props.order.delivery.name}</p>
                                <Price
                                    price={props.order.cart.deliveryPrice.totalWithTax}
                                    page={"my-account"}
                                    customCurrency={props.order.cart.currency}
                                />
                            </>
                        }
                    </div>

                    <div>
                        <p className={styles["subtitle"]}>{t("MY_ACCOUNT_DELIVERY_ADDRESS")}</p>
                        <Address address={props.order.deliveryAddress}/>
                    </div>

                    <div>
                        <p className={styles["subtitle"]}>{t("MY_ACCOUNT_BILLING_ADDRESS")}</p>
                        <Address address={props.order.billingAddress}/>
                    </div>

                </div>
            </div>
        </div>
    )
}
